module.exports = __webpack_public_path__ + "static/media/sharing-overview-video.0504321f.mp4";